/**
 * The house-style limits, read from the one spec the backend validates with
 * (src/app/data/hkcm_formalia_spec.json, decided from hkcm.com's published
 * articles). The badge used to carry its own numbers and drifted from the
 * validator — a teaser of 170–200 characters on the page against 100–300 in
 * the check.
 */

import spec from '../../app/data/hkcm_formalia_spec.json'

export interface FormaliaRange {
    min: number
    max: number
}

export const FORMALIA = {
    h1: spec.character_counts.h1_title,
    teaser: spec.character_counts.teaser,
    body: spec.word_counts.news_article,
    keyPoints: spec.structure.bullet_points_summary,
    faq: spec.structure.faq,
    metaTitle: spec.character_counts.meta_title,
    metaDescription: spec.character_counts.meta_description,
    ogTitle: spec.character_counts.og_title,
    h2: spec.character_counts.h2_subheading,
    /** The Morning Briefing's story is validated as a background article. */
    briefing: spec.word_counts.background_article,
} satisfies Record<string, FormaliaRange>

/** The seven categories the CMS has; an article gets exactly one. */
export const CMS_CATEGORIES: readonly string[] = spec.categories

/** The decimal separator the house writes: a point, as hkcm.com. */
export const DECIMAL_SEPARATOR: string = spec.formatting.numbers.decimal_separator
